export const AUTH_TOKEN ="token"

export const BASE_URL ="https://admin.mailagroup.co.ug";
// export const BASE_URL ="http://localhost:8000";


